import { useQuery } from "@tanstack/react-query";

import { ListMagazineTemplatesQueryFilters, UseListMagazineTemplatesQueryOptions } from "./types";
import { getMagazineTemplatesService } from "./service";

export const listMagazineTemplatesQueryKey = ["magazine/magazine_template_admin"];

export function useListMagazineTemplatesQuery(
  filters?: ListMagazineTemplatesQueryFilters,
  options?: UseListMagazineTemplatesQueryOptions
) {
  const queryKey = listMagazineTemplatesQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getMagazineTemplatesService(filters),
    ...options,
  });
}
